import { ModuleWithProviders, NgModule } from '@angular/core';
import { PasswordStrength } from './password-strength';
import { CreditCardService } from './credit-card-service';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { ErrorHighlightDirective } from './error-highlight-directive';
import { FormsModule } from '@angular/forms';
import { CommonModule as ACommonModule } from '@angular/common';
import { TYTCommonModule } from '../common';

const DECLARATIONS = [
    ErrorMessageComponent,
    ErrorHighlightDirective
];

@NgModule({
    declarations: DECLARATIONS,
    exports: DECLARATIONS,
    imports: [
        FormsModule,
        ACommonModule,
        TYTCommonModule
    ]
})
export class ValidationModule {
    static forRoot(): ModuleWithProviders<ValidationModule> {
    return {
        ngModule: ValidationModule,
        providers: [
            PasswordStrength,
            CreditCardService
        ]
    };
}
}